import './index.scss';
import React, { ChangeEvent } from 'react';
import { Box, Typography, Link } from '@material-ui/core';
import { Checkbox } from '../Checkbox';
import { translate } from '@utils';

interface props {
  checked: boolean;
  link: string;
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
}

export const Agreement = ({ checked = false, onChange, link }: props) => {
  return (
    <Box className="agreement">
      <Checkbox checked={checked} onChange={onChange}></Checkbox>
      <Typography>
        {translate('agreement')}
        <Link className="agreement_link" underline="always" href={link} target="_blank">
          {translate('terms')}
        </Link>
      </Typography>
    </Box>
  );
};
